import { Layout } from "antd";
import "./Layout.scss";

const { Content } = Layout;

const LayoutHero: React.FC<{ children?: React.ReactNode }> = (props) => {
  const { children } = props;

  return (
    <Layout className="layout-hero">
      <Content>
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          {children}
        </div>
      </Content>
    </Layout>
  );
};

export default LayoutHero;
